// Import des styles
import './styles/main.css';

// Import des images (Webpack les traitera automatiquement)
import logoImg from './assets/images/logo.png';
import truckImg from './assets/images/OIP.png';
import heroImg from './assets/images/Hero.png';
import graffitiImg from './assets/images/graffiti.svg';
import halalLogo from './assets/images/halal-logo.svg';

// Import des images de sections
import imgFaitMaison from './assets/images/fait-maison.jpg';
import imgFoodtruck from './assets/images/foodtruck.jpg';
import imgVolaille from './assets/images/volaille.jpg';
import imgTraiteur from './assets/images/traiteur.jpg';
import imgVolaillissimes from './assets/images/volaillissimes.jpg';
import imgPlateaux from './assets/images/plateaux.jpg';
import imgSurMesure from './assets/images/sur-mesure.jpg';
import imgBucket from './assets/images/bucket.jpg';

// ============================================
// LOADER LOGIC
// ============================================
function initLoader() {
  const loader = document.getElementById('loader');
  const progress = document.getElementById('loaderProgress');
  const percentage = document.getElementById('loaderPercentage');

  if (!loader || !progress) return;

  let width = 0;
  const duration = 3000;
  const interval = 30;
  const increment = 100 / (duration / interval);

  const loadingInterval = setInterval(() => {
    width += increment;

    if (width >= 100) {
      width = 100;
      clearInterval(loadingInterval);

      setTimeout(() => {
        loader.classList.add('hidden');
      }, 500);
    }

    progress.style.width = width + '%';
    if (percentage) {
      percentage.textContent = Math.floor(width) + '%';
    }
  }, interval);
}

// ============================================
// MOBILE MENU LOGIC
// ============================================
function initMobileMenu() {
  const header = document.querySelector('.navbar');
  const burger = document.querySelector('.nav-burger');
  const menu = document.getElementById('navMenu');

  if (!header || !burger || !menu) return;

  function closeMenu() {
    header.classList.remove('is-open');
    burger.setAttribute('aria-expanded', 'false');
  }

  function toggleMenu() {
    const isOpen = header.classList.toggle('is-open');
    burger.setAttribute('aria-expanded', String(isOpen));
  }

  burger.addEventListener('click', toggleMenu);

  // Ferme le menu quand on clique sur un lien
  menu.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', closeMenu);
  });
}

// ============================================
// SMOOTH SCROLL
// ============================================
function initSmoothScroll() {
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const href = this.getAttribute('href');
      if (href.length > 1) {
        e.preventDefault();
        const target = document.querySelector(href);
        if (target) {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        }
      }
    });
  });
}

// ============================================
// INITIALISATION
// ============================================
document.addEventListener('DOMContentLoaded', () => {
  initLoader();
  initMobileMenu();
  initSmoothScroll();
});